import {createSlice} from '@reduxjs/toolkit';

import {ticketBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  error: '',
  ticket: {},
  tickets: {tickets: [], total_items: 0},
  tagDescription: {
    tagId: null,
    vendorId: null,
    requestId: null,
    html: null,
    loading: false,
    error: false
  },
  tags: []
};

export const ticketSlicer = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    emptyTickets: (state: any) => {
      state.tickets = {tickets: [], total_items: 0};
    }
  },
  extraReducers: ticketBuilder
});

export const {emptyTickets} = ticketSlicer.actions;
export default ticketSlicer.reducer;
